import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export type UserPreferences = {
  casesTableColumns: Record<string, boolean>;
};

type PreferencesState = {
  preferences: UserPreferences;
};

export const DEFAULT_PREFERENCES: UserPreferences = {
  casesTableColumns: {
    caseName: true,
    claimant: true,
    claimNumber: true,
    dateOfInjury: true,
    represented: true,
    qmePhysician: true,
    specialty: true,
    reportType: true,
    panelIssuedAt: false,
    created: true,
    action: true,
  },
};

const initialState: PreferencesState = {
  preferences: DEFAULT_PREFERENCES,
};

export const PreferencesStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    loadPreferences(prefs: UserPreferences) {
      patchState(store, { preferences: prefs });
    },
    setCasesTableColumns(columns: Record<string, boolean>) {
      patchState(store, {
        preferences: { ...store.preferences(), casesTableColumns: columns },
      });
    },
    reset() {
      patchState(store, initialState);
    },
  })),
);
